<template>
  <div>
    <h2 class="msg-head">{{ $t('update-modal-success') }}</h2>
    <div class="msg-content">
      <img
        class="msg-logo"
        src="@/components/BaseUi/MessageModal/image/message.svg"
        alt="success message"
      />
      <!-- <p v-for="(desc, index) in options.desc" :key="index">
        <i18n v-if="desc.need" :path="desc.content" tag="p">
          <span>{{ options.dragoncodeLast4 }}</span>
          <span>{{ options.visaCardLast4 }}</span>
        </i18n>
        <template v-else>
          {{ $t(desc.content) }}
        </template>
      </p> -->
      <i18n-t keypath="update-modal-success-desc1" tag="p">
        <span>{{ cardInfo.dragoncodeLast4 }}</span>
        <span>{{ cardInfo.visaCardLast4 }}</span>
      </i18n-t>
      <p>
        {{ $t('update-modal-success-desc2') }}
      </p>
      <button class="msg-button" @click="handleClick">
        {{ $t('homePage') }}
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'UpdateCardSuccess',
    mounted() {
      console.log(this.$route.query.dragoncodeLast4, 'sadasd');
      // 通过路由 params 传参, 如果路由参数为空跳转回首页
      if (!this.$route.query.dragoncodeLast4 || !this.$route.query.visaCardLast4) {
        this.$router.push('/');
        return;
      }
      this.cardInfo.dragoncodeLast4 = this.$route.query.dragoncodeLast4;
      this.cardInfo.visaCardLast4 = this.$route.query.visaCardLast4;
    },
    data() {
      return {
        cardInfo: {
          dragoncodeLast4: '',
          visaCardLast4: '',
        },
      };
    },
    methods: {
      handleClick() {
        this.$router.push('/');
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import './index';
  @import './mobile';
</style>
